import React from "react";
import LanguageSelector from "./LanguageSelector";
import ThemeSelector from "./ThemeSelector";

// Lightweight settings modal opened from the sidebar's bottom "Settings"
// button. Aggregates the language + theme controls in one place so the
// navbar stays uncluttered.
const SettingsModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-xl bg-[var(--color-surface)] shadow-xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-[var(--color-border)]">
          <h2 className="text-lg font-semibold text-[var(--color-text-strong)]">
            Settings
          </h2>
          <button
            onClick={onClose}
            aria-label="Close"
            className="text-[var(--color-text-muted)] hover:text-[var(--color-text)] text-2xl leading-none"
          >
            ×
          </button>
        </div>

        {/* BODY */}
        <div className="px-6 py-5 space-y-5">
          <div>
            <h3 className="text-sm font-semibold text-[var(--color-text-strong)] mb-2">
              Language
            </h3>
            <p className="text-xs text-[var(--color-text-muted)] mb-2">
              Choose the interface language.
            </p>
            <LanguageSelector />
          </div>

          <div className="pt-4 border-t border-[var(--color-border)]">
            <h3 className="text-sm font-semibold text-[var(--color-text-strong)] mb-2">
              Theme
            </h3>
            <p className="text-xs text-[var(--color-text-muted)] mb-2">
              Pick a color theme.
            </p>
            <ThemeSelector />
          </div>
        </div>

        {/* FOOTER */}
        <div className="flex justify-end gap-3 px-6 py-4 border-t border-[var(--color-border)] bg-[var(--color-surface)]">
          <button
            onClick={onClose}
            className="rounded-lg bg-[var(--color-primary)] hover:bg-[var(--color-primary-hover)] text-[var(--color-on-primary)] px-4 py-2 text-sm font-semibold shadow-sm transition-colors"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default SettingsModal;
